<template>
  <div class="dialog-size-md mp-international-publishing-status-dialog">
    <div class="modal-body">
      <h2>
        {{ $t('DESIGNS.DETAILS.MP_INTPUB.HEADING') }}
      </h2>
      <p class="text-grey">
        {{ $t('DESIGNS.DETAILS.MP_INTPUB.SUBHEADING') }}
      </p>

      <div v-if="idea.approvalPending" class="color-box">
        {{ $t('DESIGNS.DETAILS.MP_KIDS_INFO') }}
      </div>

      <IdeaPublishingStatusTable
        :get-deeplink-for-locale="getDeeplinkForLocale"
        display-unavailable-deeplinks
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import mpUrlService from 'commons/api/mpUrlService/mpUrlService';
import IdeaPublishingStatusTable from './IdeaPublishingStatusTable.vue';

export default {
  name: 'MpInternationalPublishingStatusDialog',
  components: {
    IdeaPublishingStatusTable,
  },
  props: ['modalInstance', 'data'],
  computed: {
    ...mapState({
      idea: (state) => state.idea.current,
    }),
  },
  methods: {
    getDeeplinkForLocale(locale) {
      return mpUrlService.getMpDeeplink(this.idea.id, {
        locale,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';
@import 'src/scss/styleguide/type';

.mp-international-publishing-status-dialog {
  .modal-body {
    & > h2 {
      margin: 0;
    }

    & > p {
      margin: 12px 0 16px 0;
    }
  }
}

.loading-wrapper {
  margin: 48px 0;
}
</style>
